import { createProvider } from '@nvision/services/data-provider';

import type { TMSSettingsApi } from '../../models';
import * as api from './api';
import { normalizeTmsSettingsUpdate } from './normalize';

export const saveTmsSettings = createProvider((payload: TMSSettingsApi) =>
  api.saveTmsSettings(normalizeTmsSettingsUpdate(payload)),
)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('saveTmsSettings aborted');
    } else {
      console.error('saveTmsSettings was failed:', error);
    }
    throw error;
  });
